import React, { useEffect } from 'react';
import { useStyles } from 'components/VideoPlayer/useStyles';
import { useHls } from 'hooks';
import { HlsErrorType } from 'components/VideoPlayer/type';
import clsx from 'clsx';

function HlsError({ error }: { error: HlsErrorType }) {
  const classes = useStyles();

  return (
    <div className={clsx(classes.errorContainer, !error.fatal && classes.displayNone)}>
      <div className={classes.errorContent}>
        <h1 className={classes.errorTitle}>에러 발생</h1>
        <h2 className={classes.errorTitle}>{error.type}</h2>
        <h2 className={classes.errorTitle}>{error.details}</h2>
        <h2 className={classes.errorTitle}>{error.url}</h2>
      </div>
    </div>
  );
}

export default HlsError;
